import {Skeleton} from '@gwc/core'
import {type BoxProps, Box} from '@yandex-delivery/blocks'
import React, {memo} from 'react'

import * as classes from './VerticalsSkeleton@mobile.classes'

const VERTICAL_SKELETON_COUNT = 10

export const VerticalsSkeleton = memo(
  (props: BoxProps<'div'>): React.ReactElement => (
    <Box className={classes.verticalWrapper} {...props}>
      <Box className={classes.vercticalContent}>
        {Array(VERTICAL_SKELETON_COUNT)
          .fill(null)
          .map((_, i) => (
            <Skeleton key={`vertical_skeleton_${i}`} className={classes.vertical} />
          ))}
      </Box>
    </Box>
  ),
)
